module.exports = new __parcel__URL__("WebCell-0.f9823b00.png").toString();